import { CMSImage, CMSImageData, CMSImageDatas, CMSImages } from '../types';

const getUrlFromImageData = (image: CMSImageData | CMSImageDatas): string | null => {
    if (!image.data) {
        return null;
    }
    if (!Array.isArray(image.data)) {
        return image.data.attributes.url;
    }
    for (const imageData of image.data) {
        if (imageData.attributes.url) {
            return imageData.attributes.url;
        }
    }
    return null;
};

const getUrlFromImage = (image: CMSImage | CMSImages): string | null => {
    if (!image) {
        return null;
    }
    if (!Array.isArray(image)) {
        return image.url;
    }
    for (const imageData of image) {
        if (imageData.url) {
            return imageData.url;
        }
    }
    return null;
};

const isCMSImageWithData = (
    image: CMSImage | CMSImages | CMSImageData | CMSImageDatas
): image is CMSImageData | CMSImageDatas => {
    if (image === null) {
        return false;
    }
    if (!Array.isArray(image) && 'data' in image) {
        return true;
    } else if (Array.isArray(image)) {
        return !image.some((item) => !('data' in item));
    }
    return false;
};

export const getCMSImageUrl = (
    image: string | CMSImage | CMSImages | CMSImageData | CMSImageDatas
): string | null => {
    let url: string | null;
    if (typeof image === 'string') {
        url = image;
    } else if (isCMSImageWithData(image)) {
        url = getUrlFromImageData(image);
    } else {
        url = getUrlFromImage(image);
    }
    if (!url || !process.env.REACT_APP_CMS_BASE_URL) {
        return url;
    }
    if (url.startsWith(process.env.REACT_APP_CMS_BASE_URL)) {
        return url;
    }
    return `${process.env.REACT_APP_CMS_BASE_URL}${url}`;
};
